exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more[data-v-23453694] {\n  width: 20px;\n  height: 20px;\n}\n.more[data-v-23453694] .vue-ui-icon {\n  width: 16px;\n  height: 16px;\n}\n", ""]);

// exports
